import { AlarmDefinition, AlarmState, Incident } from "../interfaces/Alarms";
import { apiClient } from "./api";

export const fetchAlarmDefinitions = async (): Promise<AlarmDefinition[]> =>
  apiClient.get("/alarms").then((res) => res.data);

export const fetchAlarmStates = async (): Promise<AlarmState[]> =>
  apiClient.get("/alarms/states").then((res) => res.data);

export const fetchIncidents = async (): Promise<Incident[]> =>
  apiClient.get("/alarms/incidents").then((res) => res.data);

export const fetchAlarmById = async (
  alarmId: string,
): Promise<AlarmDefinition> =>
  apiClient.get(`/alarms/${alarmId}`).then((res) => res.data);

export const saveAlarm = async (
  alarmData: AlarmDefinition,
): Promise<AlarmDefinition> => {
  if (alarmData.config)
    alarmData.config.target_field_path =
      alarmData.config.target_field_path.replace(/\//g, "_");
  const response = alarmData.id
    ? await apiClient.put(`/alarms/${alarmData.id}`, alarmData)
    : await apiClient.post("/alarms", alarmData);
  return response.data;
};

export const deleteAlarm = async (alarmId: string): Promise<void> =>
  apiClient.delete(`/alarms/${alarmId}`);
